export { firebaseConfig } from '../firebaseConfig';

export const projectId = 'kondify-app-dev';
export const functionsBaseUrl = `https://us-central1-${projectId}.cloudfunctions.net`;

/** Build authenticated download URL for invoice PDF/XML (requires Firebase ID token). */
export async function getAuthDownloadUrl(invoiceId, format, getIdToken) {
  const token = await getIdToken();
  return `${functionsBaseUrl}/downloadInvoice?id=${encodeURIComponent(invoiceId)}&format=${format}&token=${encodeURIComponent(token)}`;
}
